import ErrorBoundary from './components/ErrorBoundary';
import { useAnalyticsInitialize } from './hooks/useAnalyticsInitialize';
import { Auth0Wrapper } from './components/Auth0Wrapper/Auth0Wrapper';
import MiddlewareWrapper from './components/MiddlewareWrapper/MiddlewareWrapper';
import { Router } from './Router';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 10 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const App = function App() {
  useAnalyticsInitialize();

  return (
    <StrictMode>
      <ErrorBoundary>
        <MiddlewareWrapper>
          <QueryClientProvider client={queryClient}>
            <Auth0Wrapper>
              <Router />
            </Auth0Wrapper>
          </QueryClientProvider>
        </MiddlewareWrapper>
      </ErrorBoundary>
    </StrictMode>
  );
};

export default App;
